/* Elyseye interactions: sliders, tabs, sticky add-to-cart. Event delegation → works in the theme editor too. */
(function () {
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-ely-prev],[data-ely-next]');
    if (nav) {
      var track = nav.closest('[data-ely-slider]').querySelector('[data-ely-track]');
      var card = track.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({ left: nav.hasAttribute('data-ely-next') ? step : -step, behavior: 'smooth' });
      return;
    }
    var tab = e.target.closest('[data-ely-tabs] [role="tab"]');
    if (tab) { selectTab(tab); return; }
    if (e.target.closest('[data-ely-sticky-go]')) {
      var form = document.querySelector('.product__info-container') || document.querySelector('product-info');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ely-tabs] [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    selectTab(next); next.focus();
  });

  function selectTab(tab) {
    var root = tab.closest('[data-ely-tabs]');
    root.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-ely-sticky]');
    var target = document.querySelector('.product-form__buttons') || document.querySelector('.product__info-container');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      bar.querySelector('[data-ely-sticky-go]').tabIndex = passed ? 0 : -1;
    });
    io.observe(target);
  }
  if (document.readyState !== 'loading') initSticky(); else document.addEventListener('DOMContentLoaded', initSticky);
  document.addEventListener('shopify:section:load', initSticky);

  /* Theme editor: select the tab that owns the clicked block */
  document.addEventListener('shopify:block:select', function (e) {
    var t = document.getElementById('tab-' + e.detail.blockId);
    if (t) selectTab(t);
  });
})();
/* Opinie – kropki i automatyczne przesuwanie w pętli (mały kafelek) v2 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function step(track) {
    var c = track.children;
    return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth;
  }
  function current(track) { return Math.round(track.scrollLeft / step(track)); }
  function goTo(track, i) {
    var n = track.children.length;
    if (!n) return;
    i = (i + n) % n;
    track.scrollTo({ left: i * step(track), behavior: reduce ? 'auto' : 'smooth' });
  }
  function sync(track) {
    var slider = track.closest('[data-ely-slider]');
    if (!slider) return;
    var i = current(track);
    slider.querySelectorAll('[data-ely-dot]').forEach(function (d, j) {
      d.setAttribute('aria-current', j === i ? 'true' : 'false');
    });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ely-track]')) sync(t);
  }, true);
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-ely-dot]');
    if (!dot) return;
    var track = dot.closest('[data-ely-slider]').querySelector('[data-ely-track]');
    goTo(track, parseInt(dot.getAttribute('data-ely-dot'), 10));
  });
  function initAutoplay(root) {
    root.querySelectorAll('[data-ely-autoplay]').forEach(function (slider) {
      if (slider.elyTimer) return;
      var track = slider.querySelector('[data-ely-track]');
      if (!track || track.children.length < 2) return;
      var pausedUntil = 0, hover = false;
      var delay = parseInt(slider.getAttribute('data-ely-autoplay'), 10) * 1000;
      slider.addEventListener('mouseenter', function () { hover = true; });
      slider.addEventListener('mouseleave', function () { hover = false; });
      ['touchstart', 'touchend', 'click'].forEach(function (ev) {
        slider.addEventListener(ev, function () { pausedUntil = Date.now() + delay; }, { passive: true });
      });
      slider.elyTimer = setInterval(function () {
        if (hover || document.hidden || Date.now() < pausedUntil) return;
        goTo(track, current(track) + 1);
      }, delay);
    });
  }
  if (document.readyState !== 'loading') initAutoplay(document);
  else document.addEventListener('DOMContentLoaded', function () { initAutoplay(document); });
  document.addEventListener('shopify:section:load', function (e) { initAutoplay(e.target); });
})();
/* Animacja pojawiania się przy przewijaniu */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('ely-reveal-on');
  var sel = '.ely .ely-head, .ely .ely-media, .ely-quote, .ely-feature, .ely-result, .ely-box, .ely-step, .ely-compare';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  function init(root) {
    root.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-ely-rev')) return;
      if (el.closest('.ely-hero') || el.closest('[data-ely-track]')) return;
      el.setAttribute('data-ely-rev', '');
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = (Math.min(i, 3) * 90) + 'ms';
      el.classList.add('ely-rev');
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();